import "../list.js";

window.AssessmentBuilder ??= {};
window.AssessmentBuilder.Views ??= {};

AssessmentBuilder.Views.CompletionPageList = class CompletionPageList extends AssessmentBuilder.Views.List {
  constructor() {
    super(...arguments);
    this.initialize = this.initialize.bind(this);
    this.render = this.render.bind(this);
  }

  initialize() {
    super.initialize(...arguments);
    this.listenTo(this.collection, "add remove", this.render);
    this.listenTo(this.collection, "change:minScore", this.render);
    return (this.selected = []);
  }

  render() {
    this.collection.sort(); // Sort the list because we don't drag and drop these ourselves
    return super.render();
  }
};
AssessmentBuilder.Views.CompletionPageList.prototype.tagName = "completion-page-list";
AssessmentBuilder.Views.CompletionPageList.prototype.selectedCss = "selected";
AssessmentBuilder.Views.CompletionPageList.prototype.listItemViewClass = "AssessmentBuilder.Views.CompletionPage";
